<template>
  <CCard accent-color="secondary">
    <CCardHeader v-if="!icon">
      <slot name="header" >
        <CIcon v-if="icon" :name="icon"/> <span class="font-weight-bold">{{caption}}</span>
        <div class="card-header-actions">
          <CButton size="sm" color="success" shape="pill" variant="outline"> <CIcon name="cil-library-add"/> </CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody class="p-0">
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        pagination
      >
        //

        <template #no="{index,item}">
          <td>
            <div class="text-center">{{index+1}}</div>
          </td>
        </template>
        <template #weekNumber="{item}">
          <td>
            <div class="text-center">{{item.weekNumber}}</div>
          </td>
        </template>
        <template #lectureHours="{item}">
          <td>
            <div class="text-center">{{item.lectureHours}}</div>
          </td>
        </template>

        <template #activity="{item}">
          <td>
            <div v-html="item.activity"></div>
          </td>
        </template>

        <template #instructorName="{item}">
          <td>
            <div class="text-center">{{item.instructorName}}</div>
          </td>
        </template>

        <template #instructor="{item}">
          <td>
            <CRow>
              <CCol class="text-center">
                <CButton size="sm" color="info" shape="pill" variant="outline" @click="onchangeInstructor(item)">
                  <CIcon :name="(item.instructor == true)?'cil-check':''"/>
                </CButton>
              </CCol>
            </CRow>
          </td>
        </template>
        <template #codication="{item}">
          <td>
            <CRow>
              <CCol class="text-center">
                <CButton size="sm" color="info" shape="pill" variant="outline" @click="onchangeCodication(item)">
                  <CIcon :name="(item.codication == true)?'cil-check':''"/>
                </CButton>
              </CCol>
            </CRow>
          </td>
        </template>

        <template ##="{item}">
          <td>
            <CRow>
              <CCol>
                <CButton size="sm" color="info" shape="pill" variant="outline" @click="onRemove(item)" >
                  <CIcon name="cil-trash"/>
                </CButton>
              </CCol>
            </CRow>
          </td>
        </template>
        <template #add="{item}">
          <td>
            <CRow>
              <CCol>
                <CButton size="sm" color="info" shape="pill" variant="outline" @click="onAddInstructors(item)" >
                  <CIcon name="cil-plus"/>
                </CButton>
              </CCol>
            </CRow>
          </td>
        </template>

        <template #action="{item}">
          <td>
            <CRow>
              <CCol class="text-center">
                <CButton class="mr-2" size="sm" color="info" shape="pill" variant="outline" @click="onRemove(item)" >
                  <CIcon name="cil-clipboard"/>
                </CButton>
                <CButton class="mr-2" size="sm" color="warning" shape="pill" variant="outline" @click="onRemove(item)" >
                  <CIcon name="cil-clone"/>
                </CButton>
                <CButton size="sm" color="danger" shape="pill" variant="outline" @click="onRemove(item)" >
                  <CIcon name="cil-trash"/>
                </CButton>
              </CCol>
            </CRow>
          </td>
        </template>

<!--        <template #status="{item}">-->
<!--          <td>-->
<!--            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>-->
<!--          </td>-->
<!--        </template>-->
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'TableList',
  props: {
    items: Array,
    fields: {
      type: Array,
    },
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    onchangeInstructor(item){
      for(var i=0; i<this.items.length; i++){
        if(this.items[i].userId == item.userId){
          this.items[i].instructor = !item.instructor
        }
      }
      this.$emit("instructor",item)
    },
    onchangeCodication(item){
      for(var i=0; i<this.items.length; i++){
        if(this.items[i].userId == item.userId){
          this.items[i].codication = !item.codication
        }
      }
      this.$emit("codication",item)
    },
    onRemove(item){
      this.items = this.items.filter(function(obj) {return obj != item;})
      this.$emit("removeInstructor",item)
    },

    onAddInstructors(item){
      this.$emit("addInstructor",item)
    }
  }
}
</script>
